/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';

import { AppContext } from '@powdr/context';
import { chunkArray } from '@powdr/utils';

import { DorMeasurementItem } from './components';
import { MeasurementGroup, StyledDorMeasurements } from './styles';

export const DorMeasurements = ({
  className = '',
  columnOption = 2,
  rowOption = null,
  mobileItemGrouping = null,
  parentColorProfile = null,
  isFromTV = false,
  relationships,
}) => {
  const { isMobile } = useContext(AppContext);
  const measurements = useMemo(() => relationships?.measurements || [], [relationships]);
  const displayMeasurements = useMemo(() => {
    if (isMobile && mobileItemGrouping && Number.isInteger(mobileItemGrouping)) {
      return chunkArray(measurements, mobileItemGrouping);
    }
    return [measurements];
  }, [measurements, mobileItemGrouping, isMobile]);

  return (
    <StyledDorMeasurements
      className={className}
      $numItems={measurements.length}
      $secondRowItems={measurements.length % 4}
      $columns={columnOption || 2}
      $rows={rowOption || null}
      $ignoreMobileColumns={mobileItemGrouping}
    >
      {displayMeasurements.map((group) => {
      // Helper function to render a measurement item
        const renderItem = (m) => (
          <DorMeasurementItem
            key={m.id}
            className={classNames({
              'mobile-grouped-item': isMobile && mobileItemGrouping,
              'tv-measurement-item': isFromTV,
            })}
            measurementLabel={m?.measurementLabel || null}
            measurementType={m?.measurementType || null}
            measurementDisplayType={m?.measurementDisplayType || null}
            ignoreLiftTypes={m?.ignoreLiftTypes || []}
            ignoreTrailTypes={m?.ignoreTrailTypes || []}
            ignoreGroomStatus={m?.ignoreGroomStatus || []}
            includeInOpenCount={m?.includeInOpenCount || []}
            liftsTrailsMeasurement={m?.liftsTrailsMeasurement || null}
            snowReportMeasurement={m?.snowReportMeasurement || null}
            icon={m?.icon || null}
            lift={m?.lift || {}}
            trail={m?.trail || {}}
            road={m?.road || {}}
            terrain={m?.terrain || {}}
            retailService={m?.retailService || {}}
            sensor={m?.sensor?.value ? m.sensor.value.replace(/ .*/, '') : null}
            sensorLocation={m?.sensorLocation ? m?.sensorLocation : null}
            sectors={m?.sectors?.length > 0 ? m.sectors.map((s) => s.uuid) : []}
            season={m?.filterBySeason || null}
            parentColorProfile={parentColorProfile}
          />
        );

        if (isMobile && mobileItemGrouping) {
          return (
            <MeasurementGroup key={`group-${group[0].id}`}>
              {group.map(renderItem)}
            </MeasurementGroup>
          );
        }

        return group.map(renderItem);
      })}
    </StyledDorMeasurements>
  );
};

DorMeasurements.propTypes = {
  className: PropTypes.string,
  columnOption: PropTypes.number,
  rowOption: PropTypes.number,
  relationships: PropTypes.shape({
    measurements: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  parentColorProfile: PropTypes.string,
  isFromTV: PropTypes.bool,
  mobileItemGrouping: PropTypes.number,
};
